import { PERMISSIONS } from "@/constants";

export default [
  {
    name: "members",
    meta: {
      title: "Manage Members",
      permission_scopes: [PERMISSIONS.IS_SUPERUSER],
    },
    path: "/manage/members",
    component: () => import("@/views/pages/members"),
  },
];
